import { Box, Stack } from '@mui/material';
import type { Provider } from '@repo/api-gw-sdk';

import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';
import { SidePanelPropsTable } from '@/components/panels/sidePanelPropsTable';
import type { FormattedField } from '@/components/table/hooks';

export const JobSummaryContentWrapper = ({
  cloudProvider,
  fields,
}: {
  cloudProvider?: Provider;
  fields: FormattedField[];
}) => {
  return (
    <Stack direction='row' gap='40px'>
      <Box width='160px'>
        {cloudProvider && (
          <CloudProviderIndicator cloudProvider={cloudProvider} />
        )}
      </Box>
      <SidePanelPropsTable withDividers>
        <tbody>
          {fields.map((field) => (
            <tr key={field.id}>
              <td className='props-col'>{field.title}</td>
              <td className='break-all'>{field.Component}</td>
            </tr>
          ))}
        </tbody>
      </SidePanelPropsTable>
    </Stack>
  );
};
